const breakpointConfig = { "xxl": 1400, "xl": 1200, "lg": 992, "md": 768, "sm": 576, "xs": 0 }
const locale = document.documentElement.getAttribute('lang')

export const breakpointDown = function (breakpointName) {
  return (window.innerWidth < breakpointConfig[breakpointName])
}

export const breakpointUp = function (breakpointName) {
  return (window.innerWidth >= breakpointConfig[breakpointName])
}

export function formatNumber(num, decs = 0) {
  return num.toLocaleString(locale, { maximumFractionDigits: decs });
}

// Check if `child` is a descendant of `parent`
export function isDescendant(parent, child) {
  let node = child.parentNode;
  while (node) {
    if (node === parent) {
      return true;
    }

    // Traverse up to the parent
    node = node.parentNode;
  }

  // Go up until the root but couldn't find the `parent`
  return false;
};